import * as Yup from 'yup';

import { isAdultDOB, isValidDOB } from '@utils/dates';

export const DOBValidator = Yup.string().test({
  message: 'Date of birth cannot be in the future.',
  test: (value: string | undefined) => {
    if (!value) {
      // Treat missing as valid since it's handled by the required validator
      return true;
    }

    return isValidDOB(value);
  },
});

export const AdultDOBValidator = DOBValidator.test({
  message: 'You must be at least 18 years old',
  test: (value: string | undefined) => {
    if (!value) {
      // Treat missing as valid since it's handled by the required validator
      return true;
    }

    return isAdultDOB(value);
  },
});
